export default __webpack_public_path__ + "static/media/check.727207fb.svg";